import "../../styles/auth/auth.css";

const NameInput = (props = {}) => {
  const { firstName, setFirstName, lastName, setLastName, loading } = props;

  return (
    <div className="name-input-container">
      <label className="label-row">
        <div>
          First Name <p className="red-text">*</p>
        </div>
        <input
          type="text"
          placeholder="FirstName"
          value={firstName}
          className="name-input"
          onChange={(e) => setFirstName(e.target.value)}
          disabled={loading}
          required
        />
      </label>
      <label className="label-row">
        <div>
          Last Name <p className="red-text">*</p>
        </div>
        <input
          type="text"
          placeholder="LastName"
          value={lastName}
          className="name-input"
          onChange={(e) => setLastName(e.target.value)}
          disabled={loading}
          required
        />
      </label>
    </div>
  );
};

export default NameInput;
